import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@afosto/app-components-react/Dialog';
import RadioGroup from '@afosto/app-components-react/RadioGroup';
import { FormattedMessage } from 'react-intl';
import translations from './translations';

const ORDER_TYPES = ['return', 'cancellation', 'order', 'purchase'];

const OrderTypeDialog = ({ isOpen, onClose, onSelect, type }) => {
  const intl = useIntl();
  const [selectedType, setSelectedType] = useState(type);

  const orderOptions = ORDER_TYPES.map(orderType => ({
    label: intl.formatMessage({
      id: `orderTypeOptions.${orderType}`,
      defaultMessage: orderType,
      description: `Label of the order type option ${orderType}`,
    }),
    value: orderType,
  }));

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth>
      <DialogTitle>{intl.formatMessage(translations.title)}</DialogTitle>
      <DialogContent>
        <RadioGroup
          value={selectedType}
          name="type"
          options={orderOptions}
          onChange={(ev, newValue) => setSelectedType(newValue)}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose} style={{ marginRight: 'auto' }}>
          <FormattedMessage {...translations.actions.cancel} />
        </Button>
        <Button
          autoFocus
          variant="contained"
          onClick={() => onSelect(selectedType)}
          color="primary"
        >
          <FormattedMessage {...translations.actions.continue} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

OrderTypeDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSelect: PropTypes.func,
  type: PropTypes.string,
};

OrderTypeDialog.defaultProps = {
  isOpen: false,
  onClose: undefined,
  onSelect: undefined,
  type: '',
};

export default OrderTypeDialog;
